import React, { PropsWithChildren } from "react";
import { createClasses } from "@bloomberg/media-ui-core";
import styles from "./style.module.css";

type TableHeaderProps = {
  className?: string;
};

export default function TableHeader(
  props: PropsWithChildren<TableHeaderProps>
) {
  return (
    <thead>
      <tr className={createClasses(styles.tableHeader, props.className)}>
        {props.children}
      </tr>
    </thead>
  );
}
